<template>
  <el-select
    v-if="options.length"
    v-model="value"
    placeholder="Select integration format"
    :disabled="disabled"
    @update:modelValue="updated"
  >
    <el-option
      v-for="item in options"
      :key="item.key"
      :label="item.label"
      :value="item.key"
    />
  </el-select>
  <router-link
    v-else
    to="/integrations/new"
    target="_blank"
    class="el-button el-button--primary is-plain"
  >
    <el-icon>
      <PlusElementIcon />
    </el-icon>
    <span>Add feed format</span>
  </router-link>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from 'vue'
import { useFeedFormatsStore } from '@/apps/traforama/store/feedFormats'
import useResize from '@/hooks/useResize'
import { IFeedFormatsPayload } from '@/apps/traforama/interfaces/feedFormats'

type FeedFormat = {
  key: number
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'FeedFormatSelector',
  props: {
    modelValue: {
      type: Number,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const feedFormatsStore = useFeedFormatsStore()
    const options = computed(() => {
      return Object.values(feedFormatsStore.items).map((obj: any) => {
        return {
          key: obj.attributes.id,
          label: `${obj.attributes.name}. ${obj.attributes.type}`,
          disabled: false
        }
      })
    })

    const { isDesktop } = useResize()

    function updated(newValue: FeedFormat) {
      context.emit('update:modelValue', newValue)
    }

    onMounted(() => {
      feedFormatsStore.SetFilters({ disabled: false })
      feedFormatsStore.SetLimit(50)
      feedFormatsStore.FetchItems()
    })

    return { options, updated, isDesktop, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
